<template>
    <IntegrationsTabs tab-key="available">
        <div class="flex flex-wrap items-start self-stretch gap-6 pb-[21px]">
            <EcomailIntegrationBox />
        </div>
    </IntegrationsTabs>
</template>

<script lang="ts" setup>
import EcomailIntegrationBox from "../components/Ecomail/EcomailIntegrationBox.vue";
</script>
